import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouletteHistoryService {
    private readonly maxHistory = 200;
    private readonly totalNumbers = 38;
    private readonly defaultDisplayCount = 6;
    private readonly historySubject = new BehaviorSubject<number[]>(
        Array.from({ length: 200 }, () => Math.floor(Math.random() * this.totalNumbers))
    );

    getHistory$(): Observable<number[]> {
        return this.historySubject.asObservable();
    }

    getCurrentHistory(): number[] {
        return this.historySubject.value;
    }

    addNumber(number: number): void {
        const currentHistory = this.historySubject.value;
        const updatedHistory = [...currentHistory, number].slice(-this.maxHistory);
        this.historySubject.next(updatedHistory);
    }

    setHistory(history: number[]): void {
        this.historySubject.next(history.slice(-this.maxHistory));
    }

    clearHistory(): void {
        this.historySubject.next([]);
    }

    getHotNumbers(count: number = this.defaultDisplayCount): number[] {
        const history = this.getCurrentHistory();
        const frequency = this.calculateFrequency(history);

        return Object.entries(frequency)
            .sort(([, a], [, b]) => b - a)
            .slice(0, count)
            .map(([number]) => Number(number));
    }

    getColdNumbers(count: number = this.defaultDisplayCount): number[] {
        const history = this.getCurrentHistory();
        const frequency = this.calculateFrequency(history);

        const allNumbers = Array.from({ length: this.totalNumbers }, (_, i) => i);

        allNumbers.forEach((number) => {
            if (!(number in frequency)) {
                frequency[number] = 0;
            }
        });

        return Object.entries(frequency)
            .sort(([, a], [, b]) => a - b)
            .slice(0, count)
            .map(([number]) => Number(number));
    }

    private calculateFrequency(numbers: number[]): Record<number, number> {
        return numbers.reduce<Record<number, number>>((acc, number) => {
            acc[number] = (acc[number] || 0) + 1;
            return acc;
        }, {});
    }
}
